//hooks:
import {TimeStampToSeconds} from "../../../_metronic/_helpers";
import api from "../../util/api";

const getNodeAppearances = (videoId, node) => {
    return api
        .post(`v2/api/videos/${videoId}/netgraph/appearances`, node)
        .then(({data}) => {
            return data;
        })
        .catch(err => {
            return err;
        });
};

export const getAppearances = async ({
                                         node = {},
                                         videoIdUrl = "",
                                         setIsGettingAppearances = () => {
                                         },
                                         selectedInsights = [],
                                         setNodeAppearances = () => {
                                         },
                                         choosingSearchType = () => {
                                         },
                                         term = "",
                                     }) => {
    try {
        setIsGettingAppearances(true);

        const isSpeakerFn = () => {
            if (node.selectedNode && node.selectedNode.node === "speaker") {
                /*(from track page)*/
                return {
                    ...node.selectedNode,
                    name: node.text,
                };
            } else if (node.node && node.node === "speaker") return node;
            return undefined;
        };
        const isSpeaker = isSpeakerFn();

        const getData = () => {
            if (isSpeaker)
                return {
                    speaker_id: `${isSpeaker.id}`,
                };
            return {
                id: node.id || node.selectedNode?.id,
                type: node.type,
            };
        };
        const data = getData();
        const nameToSearch = isSpeaker?.name || term || node.text || node.name;
        const selectedType = selectedInsights[0];
        const id = isSpeaker?.node || node.type || selectedType.key;

        const appearances = await getNodeAppearances(videoIdUrl, data);

        if (appearances) {
            setIsGettingAppearances(false);

            if (appearances.data) {
                const appearancesWithTooltip = appearances.data.map(appearance => ({
                    ...appearance,
                    text: nameToSearch,
                }));

                const sortedAppearances = sortHits(appearancesWithTooltip);

                setNodeAppearances(sortedAppearances);
            }
            choosingSearchType(nameToSearch, id);
        } else setNodeAppearances([]);
    } catch (err) {
    }
};

export const checkIsConceptualSearch = (key = "") => {
    const CONCEPTUAL_KEYS = ["category1", "category2", "category3", "concepts", "speaker"];

    return CONCEPTUAL_KEYS.some(arrKey => arrKey === key);
};

export const getMergedAndSortedHits = ({videoHits = [], nodeAppearances = []}) => {
    const mergedAppearancesWithCoincidences = [].concat(nodeAppearances || [], videoHits);
    const sortedMatches = !!mergedAppearancesWithCoincidences?.length
        ? sortHits(mergedAppearancesWithCoincidences)
        : [];

    return sortedMatches;
};

export const sortHits = hits => {
    return hits?.length
        ? hits.sort((a, b) => {
            const startA = a.start;
            const startB = b.start;
            return TimeStampToSeconds(startA) - TimeStampToSeconds(startB);
        })
        : [];
};

export const filterAndUnpackHits = (rawHits = []) => {
    const videosHits = filterMatchingHits(rawHits);

    return videosHits;
};

export const filterMatchingHits = (rawHits = []) => {
    let hits = [];

    rawHits.forEach(h =>
        h?.content?.forEach((caption, i) => {
            const {matchLevel, value} = h._highlightResult.content[i].text;

            if (matchLevel !== "none") {
                hits.push({text: value || caption.text, start: caption.start, end: caption.end, videoId: h.video.id});
            }
        })
    );

    return hits;
};

export const parseHits = (rawHits = []) => {
    let hits = [];

    rawHits.forEach(h =>
        h?.content?.forEach((caption, i) => {
            const {value} = h._highlightResult.content[i].text;           
            hits.push({text: value || caption.text, start: caption.start, end: caption.end, videoId: h.video.id});
        })
    );

    return hits;
};